import * as React from 'react';
import {observer} from 'mobx-react';
import {CatalogEntity} from '../../lib/Entity/CatalogEntity';
import {CatalogDisplayMode} from '../../lib/Controller/CatalogController';
import {PagesSlider} from './PagesSlider';

import './style.scss';

interface CatalogPreviewProps {
  catalog: CatalogEntity;
  displayMode: CatalogDisplayMode;
  updateActivePage: (pageIndex?: number) => void;
}

@observer
export class CatalogPreview extends React.Component<CatalogPreviewProps, {}> {
  render() {
    return (
      <div className='catalog-preview-container'>
        <PagesSlider {...this.props} />
      </div>
    );
  }
}
